import React, { useEffect, useState } from 'react'

import './adminpanel.css'
import { useAuthContext } from '../../Hooks/useAuthContext'
import axios from 'axios'
import { FaAlignLeft, FaSignOutAlt, FaTimes, FaUserAlt } from 'react-icons/fa'
import { toast } from 'wc-toast'
import AdminConfirm from './AdminConfirm'
import { Link, useNavigate } from 'react-router-dom'
import AdminSidebar from './AdminSideBar'
import Loader from '../../Component/Loader/Loader'

function Users() {
  const navigate                              = useNavigate()
  const { user, dispatch }                    = useAuthContext()
  const [sidemenu, setSideMenu]               = useState(false)
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false)
  const [dashUser, setDashUser]               = useState(false)
  const [data, setData]                       = useState([])
  const [editMode, setEditMode]               = useState(false)
  const [userId, setUserId]                   = useState(null)
  const [confirm, setConfirm]                 = useState(false)
  const [updateTrigger, setUpdateTrigger]     = useState(null)
  const [loading, setLoading]                 = useState(true)
  const [formData, setFormData]               = useState({
    currency: '',
    amount: { USD: '', EUR: '', GBP: '' },
    msg: '',
  })

  /* Auth guard */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/isadmin`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => {
      if (r.data.admin)     { /* ok */ }
      else if (r.data.user) navigate('/admin-panel')
      else                  navigate('/')
    }).catch(e => console.log(e))
  }, [user.token])

  /* Fetch users */
  useEffect(() => { fetchUsers() }, [user.token, updateTrigger])

  const fetchUsers = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/users`, {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      setData(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const logout = () => {
    dispatch({ type: 'LOGOUT', payload: null })
    setTimeout(() => navigate('/rf-admin'), 3000)
  }

  const handleChange = (e) => {
    const { id, value } = e.target
    setFormData(prev => ({ ...prev, [id]: value }))
  }

  const handleEditClick = (id, balance) => {
    setUserId(id)
    setFormData({
      currency: 'USD',
      amount: { USD: balance.USD || '', EUR: balance.EUR || '', GBP: balance.GBP || '' },
    })
    setEditMode(true)
  }

  const handleDelete = (id) => {
    setUserId(id)
    setConfirm(true)
  }

  const onConfirmDelete = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/admin/delete-user/${userId}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      toast.success('Deleted Successfully')
      setConfirm(false)
      setUpdateTrigger(prev => !prev)
    } catch (error) {
      console.error(error)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/update-balance/${userId}`,
        {
          currency: formData.currency,
          amount:   formData.amount[formData.currency],
          msg:      formData.msg,
        },
        { headers: { Authorization: `Bearer ${user.token}` } }
      )
      toast.success('Balance Updated Successfully')
      setEditMode(false)
      setUpdateTrigger(prev => !prev)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className="admin dashboard">

      {/* ── Header ──────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <p>
              {process.env.REACT_APP_APP_NAME}
              <span className="admin-badge">Admin</span>
            </p>
          </Link>
          <FaAlignLeft size={18} onClick={() => {
            setShouldMenuSlide(true)
            setSideMenu(!sidemenu)
          }} />
        </div>

        <div className="left-side">
          <div className="dh-avatar" onClick={() => setDashUser(p => !p)}>
            <FaUserAlt size={14} />
          </div>
          {dashUser && (
            <div className="user-menu">
              <p className="logout" onClick={logout}>
                <FaSignOutAlt size={13} /> Logout
              </p>
            </div>
          )}
        </div>
      </div>

      {/* ── Sidebar — direct child of .dashboard ────────── */}
      {sidemenu && (
        <AdminSidebar
          shouldMenuSlide={shouldMenuSlide}
          onClose={() => setSideMenu(false)}
        />
      )}

      {/* ── Body ─────────────────────────────────────────── */}
      <div className="dashboard-main-section">
        <div className="loan-container">

          <div className="table-head">
            <div>
              <div className="db-breadcrumb">Admin &nbsp;/&nbsp; <span>Users</span></div>
              <h2>Users</h2>
            </div>
          </div>

          {loading ? (
            <Loader />
          ) : (
            <div className="db-card">
              <div className="db-card__bar" />
              <div className="loan-table">
                <table className="equal-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Account No.</th>
                      <th>Email</th>
                      <th>Country</th>
                      <th>USD</th>
                      <th>EUR</th>
                      <th>GBP</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map(u => (
                        <tr key={u._id}>
                          <td>{u.firstname} {u.lastname}</td>
                          <td>{u.accountNumber}</td>
                          <td>{u.email}</td>
                          <td>{u.country}</td>
                          <td>${u.balance.USD.toFixed(2)}</td>
                          <td>€{u.balance.EUR.toFixed(2)}</td>
                          <td>£{u.balance.GBP.toFixed(2)}</td>
                          <td>
                            <div className="action-tb">
                              <button
                                className="db-btn db-btn--ghost db-btn--sm"
                                onClick={() => handleEditClick(u._id, u.balance)}
                              >
                                Edit
                              </button>
                              <button
                                className="db-btn db-btn--danger db-btn--sm"
                                onClick={() => handleDelete(u._id)}
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="no-loan-message">No users found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

        </div>
      </div>

      {/* ── Edit balance overlay ─────────────────────────── */}
      {editMode && (
        <div className="deposits-form">
          <button className="wd-close" onClick={() => setEditMode(false)} aria-label="Close">
            <FaTimes size={14} />
          </button>
          <div className="send-money-container" style={{ width: '100%', maxWidth: '520px' }}>
            <form className="send-money-form" onSubmit={handleSubmit}>
              <h2>Edit User Balance</h2>

              <div className="send-money-form-group">
                <label htmlFor="currency">Currency <span>*</span></label>
                <select id="currency" value={formData.currency} onChange={handleChange} required>
                  <option value="" disabled>Select currency</option>
                  <option value="USD">USD – US Dollar</option>
                  <option value="EUR">EUR – Euro</option>
                  <option value="GBP">GBP – British Pound</option>
                </select>
              </div>

              <div className="send-money-form-group">
                <label>Amount <span>*</span></label>
                <input
                  type="number"
                  placeholder="Enter new balance"
                  value={formData.amount[formData.currency] || ''}
                  onChange={e => setFormData(prev => ({
                    ...prev,
                    amount: { ...prev.amount, [formData.currency]: e.target.value },
                  }))}
                  required
                />
              </div>

              <div style={{ padding: '0 2rem' }}>
                <button type="submit" className="send-money-send-btn">
                  Update Balance →
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Delete confirmation ──────────────────────────── */}
      {confirm && (
        <AdminConfirm
          message="Are you sure you want to delete this user?"
          onConfirm={onConfirmDelete}
          onCancel={() => setConfirm(false)}
        />
      )}

    </div>
  )
}

export default Users